








import { defineComponent } from '@vue/composition-api';
import '@google/model-viewer';

export default defineComponent({
  name: 'GoogleModelViewer',

  props: {
    gltf: {
      type: String,
      default: '',
    },
    iosSrc: {
      type: String,
      default: null,
    },
    controls: {
      type: Boolean,
      default: true,
    },
  },
});
